import Axios from "axios";
import $ from 'jquery';
import * as Misc from './misc';
import ProjectScope from './components/projectScope/projectScope';

//Axios.defaults.headers.get['Content-Type'] = 'application/json';

if (!String.prototype.endsWith) {
    Object.defineProperty(String.prototype, 'endsWith', {
        value: function(searchString, position) {
            var subjectString = this.toString();
            if (position === undefined || position > subjectString.length) {
                position = subjectString.length;
            }
            position -= searchString.length;
            var lastIndex = subjectString.indexOf(searchString, position);
            return lastIndex !== -1 && lastIndex === position;
        }
    });
}

const serverConfig = document.kvConfig;
const __hideFeatures = Misc.toBoolean(serverConfig.hide) ? 1 : 0;

function _get(url) {
  return Axios.get(url, {
      headers: {
          'Content-Type': 'application/json'
      }
  });
}

function _post(url, data) {
  return Axios.post(url, data, {
    headers: {
      "Content-Type": "application/json",
      'x-antiforgery-token': $('input[name=__RequestVerificationToken]').val()
    }
  });
}

let __urlBase = null;

function _getUrlBase() {
  if (__urlBase) return __urlBase;
  let {subDomain} = document.kvConfig;
  let {domain} = document.kvConfig;
  domain = domain || 'quotesflooring.com';
  subDomain = subDomain ? subDomain + '.' : '';
  __urlBase = (location.port === "9007"
      || location.hostname.toLowerCase().endsWith('.ngrok.io')) // Eugene's debugging in iPhone
      ? `http://${subDomain}${domain}` : "";
  return __urlBase;
}

function _urlBase() {
  return serverConfig.type === 'Fabricator' ? _getUrlBase() + '/Job/QuickQuote/' + serverConfig.userId : '.';
}

export default class JsonApi {
  static allAvailableStones(jobId, type) {
    jobId = jobId || 0;
    type = type || 'Fabricator';
    return _get(`${_getUrlBase()}/api/Public/${serverConfig.userId}/AvailableStones?jobId=${jobId}&type=${type}&loadStoneFilters=true`);
    // return _get(`${_getUrlBase()}/Job/QuickQuote/${serverConfig.userId}/AvailableStones?jobId=${jobId}&type=${type}`);
  };

  static getNewQuoteData(jobId, type) {
    jobId = jobId || 0;
    type = type || 'Fabricator';
    // let url = `${_getUrlBase()}/Job/QuickQuote/${serverConfig.userId}/GetNewQuoteData?jobId=${jobId}&type=${type}&hide=${__hideFeatures}`;
    let url = `${_getUrlBase()}/api/Public/${serverConfig.userId}/GetNewQuoteData?jobId=${jobId}&type=${type}&hide=${__hideFeatures}`;
    if (Misc.isMobile)
      url += '&w=150';
    return _get(url);
  };
  static getMenuNavigation () {
    return _get(`${_getUrlBase()}/api/PublicFabricatorVisualizerNavigation/List?FabricatorId=${serverConfig.userId}`);  //41356
  };

  static userLogin(email, password) {
    return _post(_getUrlBase() + "/api/Public/LoginClient", {email: email, password: password});
    // return _post(_urlBase() + "/LoginClient", {email: email, password: password});
  };

  static userRegister(data) {
    return _post(`${_getUrlBase()}/api/Public/RegisterClient`, data);
    // return _post(_urlBase() + "/RegisterClient", data);
  };

  static saveQuote(data) {
    return _post(_getUrlBase() + "/api/Public/SaveQuote", data);
    // return _post(_urlBase() + "/SaveMultiQuickQuote", data);
  };

  // email must be post-fixed by the /, see here
  // https://stackoverflow.com/questions/13298542/apicontroller-returns-404-when-id-contains-period
  // the accepted answer
  static resetUserPassword(email) {
    return _post(_getUrlBase() + '/api/Public/SendResetPassword', {email});
  };

  static scheduleCustomer(data) {
    return _post(_urlBase() + "/Schedule", data);
  };

  static getJobData(jobId) {
    return _get(_urlBase() + "/GetJobDataById?jobId=" + jobId);
  };

  static generateAuthenticationToken() {
    var userInfo = ProjectScope.userInfo();
    if(userInfo.phone.indexOf("555-555-5555") === -1) {
      return _get(_getUrlBase() + "/api/TwoFactorAuthentication/GenerateAuthenticationRequest?encodedCustomerId=" + encodeURIComponent(userInfo.encodedUserId));
    } else {
      return Promise.resolve("93eacff8-d2cf-488b-b10d-12c81dd806e2");
    }
  };

  static sendAuthenticationRequest(token, to, type) {
    return _post(_getUrlBase() + "/api/TwoFactorAuthentication/SendAuthenticationRequest", {token, to, type});
  };

  static validateAuthenticationRequest(token, code, phoneNumber) {
    var userInfo = ProjectScope.userInfo();
    if(token === "93eacff8-d2cf-488b-b10d-12c81dd806e2") {
      return Promise.resolve({data: code === "568127"});
    } else {
      return _post(_getUrlBase() + "/api/TwoFactorAuthentication/ValidateAuthenticationRequest", {token, code, phoneNumber, encodedCustomerId: userInfo.encodedUserId});
    }
  };
};




// WEBPACK FOOTER //
// ./src/jsonApi.js